module.exports = __webpack_public_path__ + "static/media/shape-4.23385ff0.png";